// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LBbj8Ff4qXPj8l {
  display: flow-root;
  position: relative;
  z-index: 10;
  min-height: 24px;
  padding: var(--ds-space-100, 8px) var(--ds-space-150, 12px) var(--ds-space-050, 4px);
}
.UjutGRfket217Q {
  border-bottom-right-radius: var(--ds-border-radius-200, 8px);
  border-bottom-left-radius: var(--ds-border-radius-200, 8px);
  background-color: rgba(255, 255, 255, 0.7);
}
:where(html[data-color-mode='dark']) .UjutGRfket217Q {
  background-color: rgba(29, 33, 37, 0.7);
}
`, ""]);
// Exports
export var details = `LBbj8Ff4qXPj8l`;
export var stickersBackdrop = `UjutGRfket217Q`;
export default ___CSS_LOADER_EXPORT___;
